import { API_BASE } from './api';

const STORY_API = `${API_BASE}/story-data`;

async function parseJsonResponse(res, fallbackMessage) {
  let data = null;

  try {
    data = await res.json();
  } catch (_error) {
    data = null;
  }

  if (!res.ok) {
    throw new Error(data?.error || data?.message || fallbackMessage);
  }

  return data;
}

export async function fetchMapYears() {
  const res = await fetch(`${STORY_API}/map-years`, { credentials: 'include' });
  return parseJsonResponse(res, 'Failed to load available map years.');
}

export async function fetchMapData(year) {
  const res = await fetch(`${STORY_API}/map?year=${year}`, {
    credentials: 'include',
  });
  return parseJsonResponse(res, 'Failed to load map data.');
}

export async function fetchTrendData() {
  const res = await fetch(`${STORY_API}/trend`, { credentials: 'include' });
  return parseJsonResponse(res, 'Failed to load trend data.');
}

export async function fetchAgeBreakdownData() {
  const res = await fetch(`${STORY_API}/age-breakdown`, {
    credentials: 'include',
  });
  return parseJsonResponse(res, 'Failed to load age breakdown data.');
}

export async function fetchImpactData() {
  const res = await fetch(`${STORY_API}/impact`, { credentials: 'include' });
  return parseJsonResponse(res, 'Failed to load impact data.');
}

export async function fetchSmokingStoryInitialData() {
  const [years, trend, ageBreakdown, impact] = await Promise.all([
    fetchMapYears(),
    fetchTrendData(),
    fetchAgeBreakdownData(),
    fetchImpactData(),
  ]);

  return {
    years,
    trend,
    ageBreakdown,
    impact,
  };
}
